import React from 'react';
import {FormProvider, useForm, useWatch} from "react-hook-form";
import {useHistory} from "react-router-dom";
import Field from "v4/components/form/Field/Field";
import { useProspectPageContext } from "v4/contexts/ProspectPageContext";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import 'v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/ProspectQuotesDuplicate/ProspectQuotesDuplicate.scss';
import UserService from "api/user/user";

export default function ProspectQuotesDuplicate({rowIdToDuplicate, closePopup}) {
    const {t} = usePolTranslation();
    const {replace} = useHistory();
    const {prospect} = useProspectPageContext();
    const { getRouteByNativeIdentifier } = useNavigation();

    const methods = useForm({
        defaultValues: {
            prospect: prospect?.metadata?.id ?? '',
        }
    });

    const selectedProspect = useWatch({
        control: methods.control,
        name: 'prospect',
    });

    const handleAccept = () => {
        if (selectedProspect.length > 0) {
            replace(`/${resolveUrl(getRouteByNativeIdentifier('detail_quotes')?.url, {prospect: selectedProspect})}/add?duplicateFrom=${rowIdToDuplicate}`);
            closePopup();
        }
    }

    return (
        <div className="duplicate-popup__content">
            <p>{t('duplicate_prospect_text')}</p>
            <div className="d-flex flex-column">
                <FormProvider {...methods}>
                    <Field name="prospect"
                           type="select"
                           attr={{type: 'autocomplete', autocomplete_entity: 'prospect'}}
                           constraints={{required: true}}
                           impossibleValues={'unknown_' + UserService.getCustomerId()}
                           placeholder={t('select')}
                           {...(prospect && {
                               choices: [{label: prospect.metadata.fullname, value: prospect.metadata.id}]
                           })}
                    />
                </FormProvider>
            </div>
            <div className="duplicate-popup__content__buttons">
                <button className="duplicate-popup__content__button-cancel"
                        onClick={closePopup}>
                    {t('cancel')}
                </button>
                <button className="duplicate-popup__content__button-confirm"
                        onClick={handleAccept} disabled={!selectedProspect}>
                    {t('duplicate')}
                </button>
            </div>
        </div>
    );
}
